import { createBrowserHistory } from 'history';
import {createHashHistory} from 'history'
import Globals from 'system/Globals'
const history = Globals.instance().useHashRouter? createHashHistory():createBrowserHistory();
export default history;